import { Component, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ParamContext } from '../../../shared/service/param.context';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { JhiLanguageService } from '../../../shared/core-utils';
import { UrlService } from '../../../shared/service/url.service';

@Component({
    selector: 'jhi-transaction-details-modal',
    templateUrl: './transaction-details-modal.component.html',
})
export class TransactionDetailsModalComponent implements OnInit {

    readonly url: SafeResourceUrl;

    constructor(private jhiLanguageService: JhiLanguageService,
                private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private context: ParamContext,
                public activeModal: NgbActiveModal,
                private translateService: TranslateService,
                private urlService: UrlService
    ) {
        const gid = this.route.snapshot.queryParams.gid;
        const lotId = this.route.snapshot.queryParams.lotId;
        const url = '/ibpworkbench/controller/jhipster#/transaction?restartApplication' +
            '&cropName=' + context.cropName +
            '&programUUID=' + context.programUUID +
            '&gid=' + gid + '&lotId=' + lotId + '&modal';

        const safeUrl = this.urlService.buildSafeUrl(url);
        // Fall back to a blank page if the URL is not on the allowlist.
        this.url = safeUrl !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }

    ngOnInit() {
        (<any>window).closeModal = () => {
            this.activeModal.close();
        };
    }

    cancel() {
        this.activeModal.dismiss();
        if ((<any>window.parent).closeModal) {
            (<any>window.parent).closeModal();
        }
    }
}
